import { EnvironmentProviders, makeEnvironmentProviders } from "@angular/core";
import { provideRouter } from '@angular/router';

import { ROUTES } from './app.routes';

export function provideRouting(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideRouter(ROUTES),
  ]);
}